import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import cn from 'classnames';

import { useReadNotificationByIdMutation } from '@/api/queries/notifications';
import type { NotificationDto } from '@/common/types/notification';
import { StringMain, StringSmall } from '@/components/Typography/Typography';

const formatNotificationDate = (date: string): string => {
  const d = new Date(date);
  const day = String(d.getDate()).padStart(2, '0');
  const month = String(d.getMonth() + 1).padStart(2, '0');
  const year = d.getFullYear();
  const hours = String(d.getHours()).padStart(2, '0');
  const minutes = String(d.getMinutes()).padStart(2, '0');

  return `${day}.${month}.${year} / ${hours}:${minutes}`;
};

const NotificationListItem: FC<NotificationDto> = ({
  type,
  message,
  sentAt,
  readAt,
  id,
}) => {
  const { t } = useTranslation();
  const [mutate, { isLoading }] = useReadNotificationByIdMutation();

  return (
    <li
      role="button"
      onClick={() => mutate({ id })}
      className={cn(
        'relative flex flex-col gap-2 p-2 pl-4 rounded-lg bg-white/10 overflow-clip',
        !!readAt && 'opacity-50',
        isLoading && 'pointer-events-none animate-pulse',
      )}
    >
      {type && <StringMain weight="bold">{t(type)}</StringMain>}
      {message && (
        <StringSmall className="!text-white/80 !leading-[130%]">
          {message}
        </StringSmall>
      )}
      <span className="text-[0.625rem] text-white/40">
        {formatNotificationDate(sentAt)}
      </span>
      {!readAt && (
        <span className="px-2 py-1 bg-button-green-gradient text-[0.625rem] font-bold text-white rounded-bl-lg absolute top-0 right-0 leading-none">
          {t('NEW')}
        </span>
      )}
    </li>
  );
};

export default NotificationListItem;
